import createDocumentData from "../../utils/createDocumentData";

import { Work } from "./types/Work";
import updateWork from "./updateWork";

export default function createWork(firebase, data, options) {
	data = Work.parse(createDocumentData(firebase, "works", data));

	return updateWork(firebase, data, options);
}
